import React from "react";
import ThreeCards from "../../containers/ThreeCards/ThreeCards";
import UsefulWebsite from "../../containers/UsefulWebsite/UsefulWebsite";
import { MainContainer } from "../../helpers/StyledComponents";
import ThreeBanners from "../../containers/Banner/ThreeBanners";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Scripture Union Thailand</title>
        <meta
          name="description"
          content="SU THAILAND ทำพันธกิจร่วมกับคริสตจักรและโรงเรียน เพื่อให้เด็กเยาวชนและครอบครัว ได้ยินข่าวประเสริฐของพระเจ้า"
        />
      </Helmet>
      <ThreeBanners />
      <MainContainer>
        <ThreeCards />
        <UsefulWebsite />
      </MainContainer>
    </>
  );
};

export default Home;
